'use strict';

/**
 * Constant used to signal the absence of a client-side token.
 * This is used for in spotify.com, where tokens are not
 * available to the clients, but are added on a common routing
 * layer instead.
 */
module.exports = 'NOT_A_TOKEN';
